import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'

const getEmployeesApi = Configuration.Employees_Endpoints.employees

export const retrieveEmployees = createAsyncThunk(
  'employees/retrieveEmployees',
  async ({ queries }, { getState }) => {
    const { employees } = getState()
    const res = await RestClient.getRequest(`${getEmployeesApi}?pageNo=0&pageSize=${employees?.pageSize}`, {
      headers: {
        ...(queries !== undefined ? { tenant_id: queries } : {}),
      },
    })
    return res.data
  },
)
export const getEmployeesWithPagination = createAsyncThunk(
  'employees/getEmployeesWithPagination',
  async ({ queries, actionQueries }, { getState, rejectWithValue }) => {
    const { employees } = getState()
    const filters = createReqHelper(employees, { pageNumber: queries?.pageNumber || 0 })

    const response = await RestClient.getRequest(`${getEmployeesApi}?${filters}`, {
      headers: {
        ...(actionQueries?.tenantId !== undefined ? { tenant_id: actionQueries?.tenantId } : {}),
      },
    })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return { response: response.data, pageNumber: queries?.pageNumber || 0 }
  },
)

export const searchEmployees = createAsyncThunk(
  'employees/searchEmployees',
  async ({ queries, actionQueries }, { getState, rejectWithValue }) => {
    const { employees } = getState()

    const filters = createReqHelper(employees, { activeSearch: queries, pageNumber: 0 })

    const response = await RestClient.getRequest(`${getEmployeesApi}?${filters}`, {
      headers: {
        ...(actionQueries?.tenantId !== undefined ? { tenant_id: actionQueries?.tenantId } : {}),
      },
    })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return { response: response.data, activeSearch: queries }
  },
)

function createReqHelper(store, filters) {
  const copyStore = { ...store }
  Object.entries(filters).forEach(([key, value]) => {
    copyStore[key] = value;
  });

  const {
    pageSize,
    pageNumber,
    activeSearch,
  } = copyStore

  const response = [
    `pageNo=${pageNumber || 0}`,
    `pageSize=${pageSize}`,
    `search=${activeSearch || ''}`,
  ].join('&')
  return response
}

export default retrieveEmployees
